import { Toast } from 'antd-mobile';
import { useEffect, useState } from 'react';
import { LocalTrackPublication, Participant, RemoteTrackPublication } from 'twilio-video';
import useVideoContext from '../useVideoContext/useVideoContext';
import { useAppState } from '../../state';

type TrackPublication = LocalTrackPublication | RemoteTrackPublication;

export default function usePublications(participant: Participant) {
  const [publications, setPublications] = useState<TrackPublication[]>([]);
  const { room: { localParticipant } } = useVideoContext()
  const {setIsRemoteMuteVideo} = useAppState();

  useEffect(() => {
    // Reset the publications when the 'participant' variable changes.
    setPublications(Array.from(participant.tracks.values()) as TrackPublication[]);

    const publicationAdded = (publication: TrackPublication) => {
      setPublications(prevPublications => [...prevPublications, publication]);
      if (participant !== localParticipant) {
        setIsRemoteMuteVideo(false);
      }
    }
    const publicationRemoved = (publication: TrackPublication) => {
      if (participant !== localParticipant) {
        setIsRemoteMuteVideo(true);
      }
      setPublications(prevPublications => prevPublications.filter(p => p !== publication));
    }

    participant.on('trackPublished', publicationAdded);
    participant.on('trackUnpublished', publicationRemoved);
    return () => {
      participant.off('trackPublished', publicationAdded);
      participant.off('trackUnpublished', publicationRemoved);
    };
  }, [participant]);

  return publications;
}
